import './DesktopStyle1.scss';

const DesktopStyle1 = ({ children }: { children: JSX.Element }) => {
  return children;
};

export default DesktopStyle1;
